import React from 'react'
import { FieldError, FieldErrors, useFormContext } from 'react-hook-form'

const TableGlobalError = () => {
    const { formState } = useFormContext()
    const globalError = ((formState.errors.rows as FieldErrors)?._rowError as FieldError)?.message
    return <>{globalError && <div className="global-table-error">{globalError}</div>}</>
}

export default TableGlobalError
